/* RESPONSIBLE TEAM: team-ml */
import { attr } from '@ember-data/model';
import Fragment from 'ember-data-model-fragments/fragment';
import type { BlockList } from '@intercom/interblocks.ts';

export default class FinCustomProcedureContent extends Fragment {
  @attr('array', {
    defaultValue: () => [
      {
        type: 'taskStep',
        content: {
          type: 'instructionTaskStep',
          content: [
            {
              type: 'paragraph',
              text: '',
            },
          ],
        },
      },
      {
        type: 'taskStep',
        content: {
          type: 'instructionTaskStep',
          content: [
            {
              type: 'paragraph',
              text: '',
            },
          ],
        },
      },
    ],
  })
  declare content: BlockList;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'operator/visual-builder/step/fin-custom/procedure-content': FinCustomProcedureContent;
  }
}
